// extracted by mini-css-extract-plugin
export default {"backdrop":"menu_backdrop__3Erc2","show":"menu_show__n855g","menu":"menu_menu__8xTKR","closeMenu":"menu_closeMenu__n7n8m","inner":"menu_inner__ENOlS","divider":"menu_divider__ROQLN"};